import { ISection } from '../../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { RegisterSectionsQuery } from '../../queries/register_sections_query';

class SectionGroup {
  sections: ISection[];
  parentForm?: string;
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngRegisterSectionsQuery: RegisterSectionsQuery
  ) {}

  getCurrentSectionListCourseId(sectionList: ISection[], sectionIndex: number) {
    return _4.get(sectionList[sectionIndex], '_course.id', -1);
  }

  getPreviousSectionListCourseId(sectionList: ISection[], sectionIndex: number) {
    return _4.get(sectionList[sectionIndex - 1], '_course.id', -2);
  }

  $onChanges() {
    this.sections = _4.orderBy(this.sections, ['course', '_section_type.session']);
  }

  showLineSeparator(sectionList: ISection[], sectionIndex: number): boolean {
    if (!sectionIndex) {
      return false;
    }
    const areSectionsNotEqual = !_4.isEqual(
      this.getCurrentSectionListCourseId(sectionList, sectionIndex),
      this.getPreviousSectionListCourseId(sectionList, sectionIndex)
    );
    if (areSectionsNotEqual) {
      return false;
    }
    return true;
  }

  shouldBreakCourseList(sectionList: ISection[], sectionIndex: number, isLastSection: boolean): boolean {
    const areSessionsEqual = _4.isEqual(
      _4.get(sectionList[sectionIndex], '_section_type.session', '-1'),
      _4.get(sectionList[sectionIndex + 1], '_section_type.session', '-2')
    );
    const areOfSameCourse = _4.isEqual(
      _4.get(sectionList[sectionIndex], '_course.id'),
      _4.get(sectionList[sectionIndex + 1], '_course.id')
    );

    const hasUnsatisfiedCrossCourseLinkedSection = this.ngScheduledSectionServant.hasUnsatisfiedCrossCourseCoReq(
      sectionList[sectionIndex]
    );

    return (
      isLastSection ||
      (!isLastSection && (!areSessionsEqual || !areOfSameCourse)) ||
      hasUnsatisfiedCrossCourseLinkedSection
    );
  }

  shouldShowCreditsInTheTile(sectionList: ISection[], sectionIndex: number, isLastSection: boolean): boolean {
    const isFirstOfList = _4.isEqual(sectionIndex, 0);
    const notMatchingWithPreviousTile =
      !isFirstOfList &&
      !_4.isEqual(
        this.getCurrentSectionListCourseId(sectionList, sectionIndex),
        this.getPreviousSectionListCourseId(sectionList, sectionIndex)
      );
    return isFirstOfList || notMatchingWithPreviousTile;
  }

  showCourseSectionRequired(sectionList: ISection[], sectionIndex: number, isLastSection: boolean): boolean {
    return this.shouldBreakCourseList(sectionList, sectionIndex, isLastSection) || isLastSection;
  }
}

angular.module('capability-ng-scheduler').component('sectionGroup', {
  templateUrl:
    'capability-ng-scheduler/src/views/course_scheduler/components/section_group/section_group_component.html',
  bindings: {
    parentForm: '@?',
    sections: '<',
    sectionKind: '@' // waitlist, registered, scheduled
  },
  controller: SectionGroup
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/section_group/section_group_component.ts